import { FOCUSABLE_ELEMENT_SELECTOR } from './focusable-elements-selector';

/**
 * Determines whether the given element is focusable.
 * Note: elements with a negative tab index are focusable, but not tabbable.
 */
export function isFocusable(element: any): element is HTMLElement {
  return (
    element?.matches(FOCUSABLE_ELEMENT_SELECTOR) &&
    !element?.closest('[inert], [hidden]')
  );
}
